module.exports = __webpack_public_path__ + "img/ok-black.874919d9.svg";